export class ContrasenaRequest {
    email:string;
    constructor(){
        this.email="";
    }
}
